// features/studentConsultation/studentConsultationSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  studentConsultation: [],
};

const studentConsultationSlice = createSlice({
  name: 'studentConsultation',
  initialState,
  reducers: {
    setStudentConsultation(state, action) {
      state.studentConsultation = action.payload;
    },
  },
});

export const { setStudentConsultation } = studentConsultationSlice.actions;
export default studentConsultationSlice.reducer;
